// extracted by mini-css-extract-plugin
module.exports = {"cargodashboard":"CargoOwnerDashboard_cargodashboard__38OyD","cargobody":"CargoOwnerDashboard_cargobody__bDqjk","Cargobody__content":"CargoOwnerDashboard_Cargobody__content__3uW14"};